import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { MEDIA_QUERIES, SPACER } from 'radiance-ui/lib/constants';

import COLORS from 'styles/constants/colors';

const PERSISTENT_BRANDED_SCROLLBAR_HEIGHT_PX = 7;

const persistentBrandedScrollbar = css`
  ${MEDIA_QUERIES.smUp} {
    scrollbar-color: ${COLORS.surfaceBrandBold};

    ::-webkit-scrollbar {
      height: ${PERSISTENT_BRANDED_SCROLLBAR_HEIGHT_PX}px;
    }

    ::-webkit-scrollbar-track {
      background: ${COLORS.surfaceWhite};
      box-shadow: none;
    }

    ::-webkit-scrollbar-thumb {
      background-color: ${COLORS.surfaceBrandBold};
      height: ${PERSISTENT_BRANDED_SCROLLBAR_HEIGHT_PX}px;
    }

    ::-webkit-scrollbar-button:start {
      display: block;
      background: transparent;
    }

    ::-webkit-scrollbar-button:end:increment {
      width: 100%;
      display: block;
      background: transparent;
    }
  }
`;

export const ProductCardsContainer = styled.div`
  display: flex;
  width: 100%;
  overflow-x: auto;

  ${persistentBrandedScrollbar}

  scroll-behavior: smooth;
  padding: 0 1rem 0.5rem;
  margin-bottom: ${SPACER.xlarge};

  & > div:not(:last-of-type) {
    margin-right: ${SPACER.base};
  }

  ${MEDIA_QUERIES.mdUp} {
    & > div:not(:last-of-type) {
      margin-right: ${SPACER.x3large};
    }
  }

  ${MEDIA_QUERIES.mdUp} {
    margin-bottom: 0;
    padding: 0 0 0.5rem;
  }
`;
